import React, { useState, useEffect } from 'react';
import {
  notification,
  Typography,
  Layout,
  Descriptions,
  Space,
  List,
  Skeleton,
} from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { CustomButton } from '../../../components';
import { Link } from 'react-router-dom';
import MESSAGES from '../../../enums/Messages';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import { mailHistory } from '../../../api/module/insurance_policy';
import dayjs from 'dayjs';

const breadcrumbItems = [
  {
    text: 'Revisión Pólizas',
    to: `${INTERNAL_LINKS.INSURANCE}`,
  },
  {
    text: 'Historial de Correo',
  },
];

const { Title } = Typography;
const { Content } = Layout;

export default function InsurancePolicyEmailHistory({ match }) {
  const [validationData, setValidationData] = useState(undefined);

  useEffect(() => {
    async function fetchData() {
      try {
        const validationId = match.params.validation_id;
        const res = await mailHistory(validationId);
        setValidationData(res.data);
      } catch (err) {
        console.log(err);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_GET_MSG,
          duration: 2,
        });
      }
    }
    fetchData();
  }, [match.params.validation_id]);

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        MÓDULO REVISIÓN DE PÓLIZAS
      </Title>
      {validationData ? (
        <Space direction={'vertical'} style={{ width: '100%' }}>
          <Descriptions layout="vertical" column={2} bordered>
            <Descriptions.Item label="Proyecto a revisar">
              {validationData.proyecto_nombre}
            </Descriptions.Item>
            <Descriptions.Item label="Cargo/rol a revisar">
              {validationData.cargo_nombre}
            </Descriptions.Item>
            <Descriptions.Item label="Nombre completo/Razón social">
              {validationData.contratista_nombre}
            </Descriptions.Item>
            <Descriptions.Item label="Tipo y número de documento">
              {`${validationData.tipo_identificacion} - ${validationData.identificacion}`}
            </Descriptions.Item>
            <Descriptions.Item label="No. Contrato">
              {validationData.contrato_num}
            </Descriptions.Item>
            <Descriptions.Item label="No. de la modificación">
              {validationData.modificacion_num}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions column={1} bordered layout="vertical">
            <Descriptions.Item label="Notificación">
              <List
                dataSource={validationData.email_history}
                grid={{ gutter: [0, 24], column: 1 }}
                renderItem={(item, index) => (
                  <Content>
                    <Title level={5}>
                      Email No. {index + 1} - Enviado el:{' '}
                      {dayjs(item.created_at).format('DD MMMM YYYY h:mm a')}
                    </Title>
                    <div
                      key={`insurance-email-history-${index}`}
                      dangerouslySetInnerHTML={{ __html: item.mensaje }}
                    />
                  </Content>
                )}
                pagination={false}
              />
            </Descriptions.Item>
          </Descriptions>
          <CustomButton
            type="default"
            htmlType="button"
            className={'back-button'}
            text={
              <Link
                to={`${INTERNAL_LINKS.INSURANCE}/incomplete/${validationData.proyecto_id}`}
              >
                Volver
              </Link>
            }
          />
        </Space>
      ) : (
        <Skeleton loading active />
      )}
    </Content>
  );
}
